module.exports = __webpack_public_path__ + "media/images/home/sc2-08712b843f826de1b31c4c87beffda55.webp";